<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showDialog"
      :before-close="closeDialog"
      width="1200px"
      center=""
    >
      
        <div v-html="content" style="padding:20px;"></div>
     
      <!-- <div v-html="this.registerProtocol"></div> -->
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          style="text-align:center"
          @click="closeDialog()"
        >确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import { getNews, getNewsDetail } from "@/api";
export default {
  name: 'paperDialog',
  props: ['showDialog', 'dialogTitle', 'contentType'],

  data () {
    return {
      content: '<p><span style="font-size: 20px;">致: 安康大数据运营有限公司</span></p><p><span style="font-size: 18px;"><br/></span></p><p><span style="font-size: 18px;"><br/></span></p><p><span style="font-size: 18px;">&nbsp; &nbsp; &nbsp; &nbsp;一、我单位承诺遵守贵公司供应商管理相关规定，贵公司有权对我单位经营状况资质、能力等进行必要的考察、核实。我单位承诺所提供资料信息真实有效，经考察、评价后如资料不实或不具有相关资质和能力，贵公司有权取消准入资格。&nbsp;&nbsp;</span></p><p><span style="font-size: 18px;"><br/></span></p><p>&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<span style="font-size: 18px;">二、我单位承诺遵守国家相关法律法规。在生产经营中遵守竞业禁止原则，在商务活动中遵守职业道德，不以任何形式、任何理由向贵公司员工提供个人佣金、回扣、礼金礼券、贵重物品或安排宴请、旅游等高消费娱乐活动的不正当行为。如贵公司发现我单位以不正当竞争手段拉拢、贿赂贵公司员工，一经查实，我单位接受贵公司所采取的相应处罚。</span></p><p><br/><p><p>&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<span style="font-size: 18px;">我单位保证在贵公司注册为供应商合作伙伴时所提交的全部文件内容真实、有效，承诺最近三年内未受到刑事处罚或者责令停产停业、吊销许可证或者执照、较大数额罚款等行政处罚，并愿意承担因虚构数据、虚假资料及伪造资格证明、假冒伪劣产品、非正规进货渠道等有失诚信行为所导致的一切后果。</span></p><p><br/></p>',
    }
  },
  mounted () {
    this.getContent();
  },
  methods: {
    async getContent () {
      const res = await getNews({
        current: 1,
        size: 1,
        type: this.contentType  //4-注册承诺函 5-信用承诺书 6-授权协议
      });
      if (res && res.data) {
        this.content = res.data.records[0].content;
      }
    },
    closeDialog () {
      this.$emit('closeDialog')
    }

  }
}
</script>
